// extracted by mini-css-extract-plugin
module.exports = {"container":"JoinButton__container--1i6","wide":"JoinButton__wide--2tL","join":"JoinButton__join--3WC","myCustomClassName":"JoinButton__myCustomClassName--uWE"};